import { useQuery } from "@tanstack/react-query";
import { getReportNewCustomers } from "../../api/apiReports";

export const useGetReportNewCustomers = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["report-new-customers", params],
        queryFn: () => getReportNewCustomers(params),
        retry: false,
    });

    return {
        series: data?.data || [],
        isLoading,
        error,
        refetch,
    };
};
